import { GoogleOutlined, GooglePlusOutlined } from '@ant-design/icons';
import React from 'react';

import {
  AvatarContainer,
  FloatingIconContainer,
  Picture,
} from './SsoAvatar.styles';

const iconFactories = {
  google: () => <GoogleOutlined />,
  'google-plus': () => <GooglePlusOutlined />,
} as const;

export interface SsoAvatarProps {
  icon: keyof typeof iconFactories;
  src: string;
}

function SsoAvatar({ icon, src }: SsoAvatarProps) {
  return (
    <AvatarContainer>
      <Picture src={src} />
      <FloatingIconContainer>{iconFactories[icon]()}</FloatingIconContainer>
    </AvatarContainer>
  );
}

export default SsoAvatar;
